import { ref } from 'vue';
import ApiService from '../services/api.service';
import AlertService from '../services/errors.service';

const Positions = ref({});
const isLoadingPositions = ref(false);
const Position = ref([]);
const selectPosition = ref([]);
const newPosition = ref({});
const editedPosition = ref({});
const deletedPositionId = ref(null);
const responseResult = ref(false);
export default function usePositions() {
  const getPositions = async (
    query = {
      page: 1,
      perPage: 10
    }
  ) => {
    isLoadingPositions.value = true;
    let response = await ApiService.get('/position/list?' + new URLSearchParams(query));
    Positions.value = response.data;
    isLoadingPositions.value = false;

    return response;
  };

  const getPosition = async (id) => {
    isLoadingPositions.value = true;

    let response = await ApiService.get('/position/single/' + id);
    Position.value = response.data.data;
    isLoadingPositions.value = false;
  };

  const selectPositions = async () => {
    let response = await ApiService.get('/position/select');
    selectPosition.value = response.data.data;
  };

  const storePosition = async (data) => {
    try {
      isLoadingPositions.value = true;

      const response = await ApiService.post('/position', data);

      if (response.status === 201) {
        AlertService.successMessage(response.data.message);
        newPosition.value = response.data.data;
        await getPositions();
        responseResult.value = true;
      }
    } catch (error) {
      responseResult.value = false;
    } finally {
      isLoadingPositions.value = false;
    }
  };

  const updatePosition = async (id, data) => {
    try {
      isLoadingPositions.value = true;

      const response = await ApiService.put('position/update/' + id, data);

      if (response.status === 200) {
        AlertService.successMessage(response.data.message);
        editedPosition.value = response.data.data;
        await getPositions();

        responseResult.value = true;
      }
    } catch (error) {
      responseResult.value = false;
    } finally {
      isLoadingPositions.value = false;
    }
  };

  const destroyPosition = async (id) => {
    try {
      isLoadingPositions.value = true;

      const response = await ApiService.delete('/position/' + id);

      if (response.status === 200) {
        AlertService.successMessage(response.data.message);
        deletedPositionId.value = id;
        await getPositions();

        responseResult.value = true;
      }
    } catch (error) {
      responseResult.value = false;
    } finally {
      isLoadingPositions.value = false;
    }
  };

  return {
    isLoadingPositions,
    Position,
    Positions,
    selectPosition,
    newPosition,
    editedPosition,
    deletedPositionId,
    responseResult,
    getPosition,
    getPositions,
    selectPositions,
    storePosition,
    updatePosition,
    destroyPosition
  };
}
